import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { Federacion, FederacionJSON } from './Federacion';
export class FederacionSystem {
  private readonly base = '/federacions';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getFederacionIdentifiedBy(id: string): Promise<Federacion> {
    const data = await this.requestHandler.get<FederacionJSON>(`${this.base}/${id}`);
    return Federacion.fromJSON(data);
  }

  async getList(): Promise<Federacion[]> {
    const data = await this.requestHandler.get<FederacionJSON[]>(`${this.base}`);
    return data.map((entity) => Federacion.fromJSON(entity));
  }

  async getListForDropdown(): Promise<Federacion[]> {
    const data = await this.requestHandler.get<FederacionJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => Federacion.fromJSON(entity));
  }

  async save(entity: Federacion) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<FederacionJSON, FederacionJSON>(this.base, data);
    return Federacion.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }

  getUrlForImage(image: string) {
    return this.requestHandler.requestUrl(`/uploads/images/federacion/${image}`);
  }

  async getFederacionByJugId(jugId: string): Promise<string> {
    const data = await this.requestHandler.get<string>(`${this.base}/por-jugid?jug_id=${jugId}`);
    return data;
  }
}
